import React, { useEffect, useState } from "react";
import getStorageData from "../Utils/getStorageData";
import ControlPanel from "../pages/SubAdmin/ControlPanel";
import RoomPage from "../pages/SubAdmin/RoomPage";
import Request from "../helpers/request";
import * as url from "../helpers/url_helper";
import { Images } from "../constants/images";

const slugify = (text: string) =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");

// 🔹 Custom hook to fetch and build routes
export const useSubAdminRoutes = () => {
  const [subAdminRoutes, setSubAdminRoutes] = useState<any[]>([]);
  const selectedPremiseID = getStorageData().selectedPremiseID;

  useEffect(() => {
    if (!selectedPremiseID) {
      setSubAdminRoutes([]);
      return;
    }

    const roomListApiCallNew = async () => {
      try {
        const reqObj = {
          length: 1000,
          premiseId: selectedPremiseID,
          start: 0,
        };

        const res = await Request.post(url.GET_CONTROL_ROOM_LIST_URL, reqObj);
        const roomList = res.data?.data || [];

        setSubAdminRoutes([
          {
            path: "/control-panel",
            name: "Control Panel",
            component: <ControlPanel />,
            img: Images.ControlPanel,
            activeImg: Images.ActiveControlPanel,
            isShow: selectedPremiseID ? 1 : 0,
          },
          {
            path: "/health",
            component: (
              <div style={{ marginTop: "80px", marginLeft: "10px" }}>
                <pre>
                  {JSON.stringify(
                    {
                      status: 200,
                      message: "Airhome web Service working fine...",
                    },
                    null,
                    2
                  )}
                </pre>
              </div>
            ),
            isShow: 0,
          },
          ...roomList.map((room: any) => ({
            path: `/room/${slugify(room.name)}`,
            component: <RoomPage room={room} />,
            name: room.name,
            img: require("../assets/images/Icon-rooms.png"),
            activeImg: require("../assets/images/Icons_active_rooms.png"),
            isShow: selectedPremiseID ? 1 : 0,
          })),
        ]);
      } catch (err) {
        console.error("Room List Error", err);
        setSubAdminRoutes([]);
      }
    };

    roomListApiCallNew();
  }, [selectedPremiseID]);

  return subAdminRoutes;
};
